<template>
  <!-- 语音文件 -->
  <div class="di main-wrap">
    <audio
      :ref="index"
      class="dn"
      :src="wavUrl"
      :preload="audio.preload"
      @play="onPlay"
      @error="onError"
      @pause="onPause"
      @waiting="onWaiting"
      @timeupdate="onTimeupdate"
      @loadedmetadata="onLoadedmetadata"
    ></audio>
    <div>
      <div class="boxs">
        <div class="track">
          <div class="sliders-box">
            <el-slider
              v-show="!controlList.noProcess"
              v-model="sliderTime"
              :format-tooltip="formatProcessToolTip"
              @change="changeCurrentTime"
              class="slider"
            ></el-slider>
          </div>
        </div>
      </div>
      <div
        class="currentAndAll"
      >{{ audio.currentTime | formatSecond}}/{{ audio.maxTime | formatSecond }}</div>
      <div class="operation">
        <div class="back-box" @click="minus">
          <img src="@/assets/mp4/yp_ht.png" width="100%" />
        </div>
        <div class="play-bt" @click="startPlayOrPause">
          <img :src="audio.playing | transPlayPause" width="100%" />
        </div>
        <div class="forward" @click="add">
          <img src="@/assets/mp4/yp_qj.png" width="100%" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
function realFormatSecond (second) {
  var secondType = typeof second

  if (secondType === 'number' || secondType === 'string') {
    second = parseInt(second)
    var hours = Math.floor(second / 3600)
    second = second - hours * 3600
    var mimute = Math.floor(second / 60)
    second = second - mimute * 60
    //   return hours + ':' + ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
    return ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
  } else {
    return '00:00'
  }
}

export default {
  props: {
    theUrl: {
      type: String,
      required: true
    },
    index: {
      type: String,
      required: true
    },
    theSpeeds: {
      type: Array,
      default () {
        return [1, 1.5, 2]
      }
    },
    theControlList: {
      type: String,
      default: ''
    },
    time: {
      type: Number,
      default: 15
    },
    PlayOrPause: {
      type: String,
      default: ''
    }
  },
  name: 'VueAudio',
  data () {
    return {
      L: 0,
      wavUrl: '',
      url: this.theUrl,
      audio: {
        currentTime: 0,
        maxTime: String(this.time),
        playing: false, // 是否自动播放
        muted: false, // 是否静音
        speed: 1,
        waiting: true,
        preload: 'auto'
      },
      sliderTime: 0,
      volume: 100,
      speeds: this.theSpeeds,
      controlList: {
        // 不显示下载
        noDownload: false,
        // 不显示静音
        noMuted: false,
        // 不显示音量条
        noVolume: false,
        // 不显示进度条
        noProcess: false,
        // 只能播放一个
        onlyOnePlaying: false,
        // 不要快进按钮
        noSpeed: false
      },
      cache: false
    }
  },
  methods: {
    setControlList () {
      let controlList = this.theControlList.split(' ')
      controlList.forEach((item) => {
        if (this.controlList[item] !== undefined) {
          this.controlList[item] = true
        }
      })
    },
    changeSpeed () {
      let index = this.speeds.indexOf(this.audio.speed) + 1
      this.audio.speed = this.speeds[index % this.speeds.length]
      this.$refs[this.index].playbackRate = this.audio.speed
    },
    startMutedOrNot () {
      this.$refs[this.index].muted = !this.$refs[this.index].muted
      this.audio.muted = this.$refs.audio.muted
    },
    // 音量条toolTip
    formatVolumeToolTip (index) {
      return '音量条: ' + index
    },
    // 进度条toolTip
    formatProcessToolTip (index = 0) {
      index = parseInt(this.audio.maxTime / 100 * index)
      return '进度条: ' + realFormatSecond(index)
    },
    // 音量改变
    changeVolume (index = 0) {
      this.$refs.audio.volume = index / 100
      this.volume = index
    },
    // 播放跳转
    changeCurrentTime (index) {
      this.$refs[this.index].currentTime = parseInt(index / 100 * this.audio.maxTime)
    },
    startPlayOrPause () {
      return this.audio.playing ? this.emitpause() : this.emitplay()
    },
    // 提交暂停
    emitpause () {
      const id = 'pause|' + this.index
      this.$emit('pause', id)
    },
    // 提交播放
    emitplay () {
      if (!this.cache) {
        this.wavUrl = this.theUrl
        this.$emit('loading', 'true|' + this.index)
        this.$refs[this.index].load()
      } else {
        const id = 'true|' + this.index
        this.$emit('open', id)
      }
    },
    // 开始播放
    startPlay (index) {
      this.$refs[index].play()
    },
    // 暂停
    pausePlay (index) {
      this.$refs[index].pause()
    },
    // 当音频暂停
    onPause () {
      this.audio.playing = false
    },
    // 当发生错误, 就出现loading状态
    onError () {
      this.audio.waiting = true
    },
    // 当音频开始等待
    onWaiting (res) {
      console.log('wait')
      console.log(res)
    },
    // 当音频开始播放
    onPlay (res) {
      // console.log(res)
      this.audio.playing = true
      this.audio.loading = false
      if (!this.controlList.onlyOnePlaying) {
        return
      }
      let target = res.target
      let audios = document.getElementsByTagName('audio');
      [...audios].forEach((item) => {
        if (item !== target) {
          item.pause()
        }
      })
    },
    // 当timeupdate事件大概每秒一次，用来更新音频流的当前播放时间
    onTimeupdate (res) {
      this.audio.currentTime = res.target.currentTime
      this.sliderTime = parseInt(this.audio.currentTime / this.audio.maxTime * 100)
    },
    // 当加载语音流元数据完成后，会触发该事件的回调函数
    // 语音元数据主要是语音的长度之类的数据
    onLoadedmetadata (res) {
      // console.log('loadedmetadata')
      // console.log(res)
      this.audio.waiting = false
      // this.audio.maxTime = parseInt(res.target.duration)
      // this.audio.maxTime = parseInt(this.$refs.audio.duration)
      // console.log('总时间', this.$refs.audio.duration)
      this.$emit('loading', 'false|' + this.index)
      this.startPlay(this.index)
      this.cache = true
    },
    add () {
      // 前进15s
      let currentT = parseInt(this.$refs[this.index].currentTime)
      let totalT = parseInt(this.$refs[this.index].duration)
      // console.log(this.$refs.audio)
      this.$refs[this.index].currentTime = (currentT + 5) >= totalT ? totalT : (currentT + 5)
      // console.log(currentT, totalT, this.$refs[this.index].currentTime)
      // console.log(this.$refs.audio.played)
    },
    minus () {
      // 后退15秒
      let currentT = parseInt(this.$refs[this.index].currentTime)
      this.$refs[this.index].currentTime = (currentT - 5) <= 0 ? 0 : (currentT - 5)
    }
  },
  filters: {
    formatSecond (second = 0) {
      return realFormatSecond(second)
    },
    transPlayPause (value) {
      return value ? require('@/assets/mp4/yp_zt.png') : require('@/assets/mp4/yp_bf.png')
    },
    transMutedOrNot (value) {
      return value ? '放音' : '静音'
    },
    transSpeed (value) {
      return '快进: x' + value
    }
  },
  watch: {
    url (val, oldval) {
      // console.log(val, oldval)
    },
    sliderTime (val, oldval) {
      if (val >= 98) {
        this.L = 98
        return
      }
      this.L = val
    },
    PlayOrPause (val, oldval) {
      // true  播放
      // console.log('val,oldval')
      // console.log(val)
      let result = val.split('|')
      // console.log(result)
      if (result[0] === 'false') {
        this.pausePlay(result[1])
      }
      if (result[0] === 'true') {
        this.startPlay(result[1])
      }
      // flase
    }
  },
  mounted () {
  },
  created () {
    // let audio = new Audio()
    // audio.src = this.url //audio链接
    // audio.addEventListener('loadedmetadata', function() {
    //     console.log(audio.duration)
    //     //
    // })
    this.setControlList()
  }

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.boxs {
  display: flex;
  justify-content: center;
}
.main-wrap {
  width: 420px;
  height: 134px;
}
.track {
  width: 360px;
  height: 48px;
  background: rgba(238, 238, 238, 1);
  border-radius: 2px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
}

.times {
  color: #fff;
}
.startT {
  padding: 0 15px;
  font-size: 24px;
}
.endT {
  padding: 0 15px;
  font-size: 24px;
}
.operation {
  margin-top: 10px;
  width: 200px;
}
/* .back-box {
  margin-right: 50px;
} */
/* .forward {
  margin-left: 50px;
} */
.back-box,
.forward,
.play-bt,
img {
  width: 34px;
  height: 34px;
  display: inline-block;
  margin-left: -3px;
}
.play-bt {
  margin-bottom: -1px;
}
/* .play-bt img {
  width: 17px;
  height: 17px;
}
.back-box img{
  width: 17px;
  height: 17px;
} */
.sliders-box {
  width: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.currentAndAll {
  width: 79px;
  height: 15px;
  font-size: 14px;
  float: left;
  padding-left: 20px;
  padding-top: 9px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  box-sizing: border-box;
}
.slider >>> .el-slider__button-wrapper {
  position: absolute;
  top: -17px;
}
.slider >>> .el-slider__runway {
  margin: 12px 0;
  width: 310px;
  height: 3px;
  background: rgba(194, 194, 194, 1);
  border-radius: 3px;
  position: relative;
  cursor: pointer;
  vertical-align: middle;
}
.slider >>> .el-slider__button {
  width: 8px;
  height: 8px;
  border: none;
  /* background: url(../assets/img/fubiao.gif) no-repeat center; */
  /* background-size: cover; */
  background: rgba(74, 17, 118, 1);
  border-radius: 50%;
}
.slider >>> .el-slider__bar {
  background: rgba(74, 17, 118, 1);
}
.slider /deep/ .el-slider__bar {
  height: 2px;
  border-top-left-radius: 1px;
  border-bottom-left-radius: 3px;
  position: absolute;
}
.div_box {
  height: 100px;
  position: relative;
}
.div0 {
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background: red;
  position: absolute;
  top: 0;
}
.main-wrap {
  padding: 10px 15px;
}
.slider {
  display: inline-block;
  width: 100%;
  position: relative;
  margin-left: 15px;
}
.di {
  display: inline-block;
}

.download {
  color: #409eff;
  margin-left: 15px;
}

.dn {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/solution/Rs/audiooo.vue